import { render, staticRenderFns } from "./send-table.vue?vue&type=template&id=a9549224&scoped=true&"
import script from "./send-table.vue?vue&type=script&lang=js&"
export * from "./send-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9549224",
  null
  
)

export default component.exports